<template>
  <button-grouped
    @button-click="$emit('button-click')"
    @button-mouseenter="show"
    @button-mouseleave="hide"
    :disabled="disabled"
    :is-first="isFirst"
    :is-last="isLast"
    :is-active="isActive"
  >
    <span ref="btnText">
      <slot />
    </span>
  </button-grouped>
</template>

<script>
import ButtonGrouped from '@/components/buttons/ButtonGrouped'
import { annotate } from 'rough-notation'

export default {
  name: 'ButtonNotation',
  props: {
    disabled: Boolean,
    bgColor: {
      type: String,
      default: 'brand-brown-400'
    },
    hoverBgColor: {
      type: String
    },
    type: {
      type: String,
      default: 'box'
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ButtonGrouped
  },
  computed: {
    classBgColor() {
      if (!this.isActive) {
        return `ps-bg-${this.bgColor}`
      }
    }
  },
  watch: {
    isActive(val) {
      if (!val) {
        this.hide()
      }
    }
  },
  mounted() {
    // this.notation = annotate(this.$refs.btnText, {
    //   type: this.type,
    //   color: '#FF9F90',
    //   padding: 3
    // })
    // if (this.isActive) {
    //   this.show(0)
    // }
  },
  methods: {
    show() {
      if (!this.notation) return
      this.notation.show()
    },
    hide() {
      if (!this.notation || this.isActive) return
      this.notation.hide()
    }
  }
}
</script>
